export enum USER_TYPE  {
    STUDENT = "student"
}